import React from 'react';
import Timer from 'material-ui/svg-icons/image/timer';
import { setTimers, setTimerList, setSelectedTimer } from '../../redux/timer/actions';
import { sortByProp } from '@its/util';
import { defineMessages } from 'react-intl';
import { push } from 'react-router-redux';
import { change } from 'redux-form';

const sortByIterationTime = sortByProp.bind(null, 'iterationTimer');

const messages = defineMessages({
  TIMER_FREQUENCY: {
    id: 'TIMER_FREQUENCY',
    description: 'Show timer frequency',
    defaultMessage: 'Frequency {seconds} sec.',
  },
});

const changeValues = (dispatch, values) => {
  for (const field in values) {
    dispatch(change('modifyTimer', field, values[field]));
  }
};

const getListProps = (dispatch, timers, props) => {
  const result = {
    title: 'TIMERS',
    items: [],
  };
  timers = timers.sort(sortByIterationTime);
  for (let i = 0; i < timers.length; i++) {
    result.items.push({
      key: timers[i].id,
      icon: <Timer />,
      primaryText: timers[i].name,
      secondaryText: props.intl.formatMessage(messages.TIMER_FREQUENCY, { seconds: timers[i].iterationTimer }),
      editable: false,
      deletable: false,
      onTouchTap: () => {
        dispatch(setSelectedTimer(timers[i]));
        if (props.navigate) {
          dispatch(push('/timer'));
        }
        changeValues(dispatch, timers[i]);
      },
    });
  }
  return result;
};

export const onSuccess = (result, dispatch, props) => {
  dispatch(setTimers(result.body.resultSet));
  dispatch(setTimerList(getListProps(dispatch, result.body.resultSet, props)));
  dispatch(setSelectedTimer(result.body.resultSet[0]));
  changeValues(dispatch, result.body.resultSet[0]);
};

export const onModificationSuccess = (result, dispatch) => {
  dispatch(setSelectedTimer(result.body));
};



/** WEBPACK FOOTER **
 ** ./src/routes/Timer/util.js
 **/